export const PASSWORD_STRENGTH_STEPS = 3

export const strengthToPercent = (strength) =>
  (Math.min(strength, PASSWORD_STRENGTH_STEPS) / PASSWORD_STRENGTH_STEPS) * 100
